import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles({
  root: {
    minWidth: 230,
    backgroundColor: '#EBE9FF'
  },
  value:{
    marginTop: 75,
    color: "#38527F"
  },
  name:{
    color:"#5E717A"
  }
 
});

export default function BalanceCard({balance, name, path }) {
  const classes = useStyles();

  function convertToDecimalString(num) {
    if (typeof num !== 'number') {
      return 'Invalid input: Not a number';
    }
    let decimalNum = num / 100;
    return decimalNum.toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 });

  }
  return (
    <>
        { name === "Peso" ? <Card className={classes.root}>
            <CardContent>
              <Avatar alt="Remy Sharp" src={path} />
              <Typography 
                variant="h4" 
                className={classes.value}>
               {convertToDecimalString(balance, 2)}
              </Typography>
              <Typography 
                variant="body2" 
                className={classes.name}
                >
                {name}
              </Typography>
            </CardContent>
        </Card> :
          <Card className={classes.root}>
           <CardContent>
           <Avatar alt="Remy Sharp" src={path} />
           <Typography 
             variant="h4" 
             className={classes.value}>
            0.00
           </Typography>
           <Typography 
             variant="body2" 
             className={classes.name}
             >
             {name}
           </Typography>
         </CardContent>
        </Card>
      }
    </>
  );
}
